<style lang="scss" scoped>
@import "./login.scss";
.phone-form {
    .phone {
        // color: #fff;
        text-align: center;
        // margin: 15px 0;
        font-size: 25px;
        font-weight: bold;
    }
}
</style>
<style lang="scss">
.phone {
    &-login &-input input {
        margin-top: 15px;
        background-color: transparent;
        border: none;
        border-bottom: 2px solid #fff;
        box-shadow: none !important;
        outline: none !important;
        border-radius: 0;
        font-weight: bold;
        color: #fff;
        font-size: 30px;
        text-align: center;
        &::placeholder {
            // color: #fff;
            color: #686868;
            font-size: 14px;
            font-weight: normal;
        }
    }
}
</style>
<template>
    <div>
        <div class="phone-login" @keyup.enter="submitPhoneLogin">
            <h3 v-if="loginCheckType === 0" class="login-title">{{$t('port.login.phone_login', { defaultValue: '通过手机登录' })}}</h3>
            <h3 v-else-if="loginCheckType === 1" class="login-title">{{$t('port.login.mfa_verf', { defaultValue: '通过安全验证' })}}</h3>
            <h3 v-else-if="loginCheckType === 2" class="login-title">{{$t('port.login.mfa_phone_verf', { defaultValue: '通过绑定的手机验证' })}}</h3>
            <!-- ip地址检测验证手机 -->
            <div v-if="loginCheckType === 1" class="tip">{{$t('port.login.phone_risk', { defaultValue: '检测到您的账户可能有安全风险，需要验证您的手机号' })}}</div>
            <!-- MFA手机验证 -->
            <div v-else-if="loginCheckType === 2" class="tip">{{$t('port.login.input_textcode', { defaultValue: '请输入您收到的短信验证码' })}}</div>
            <Form ref="phoneForm" class="phone-form" :model="phoneForm" :rules="rules">
                <FormItem class="login-item" prop="phone">
                    <Input v-if="loginCheckType === 0" class="phone-input" v-model="phoneForm.phone" :placeholder="$t('port.login.input_phone', { defaultValue: '请输入手机号' })"></Input>
                    <div v-else class="phone">
                        {{setBlur(phone)}}
                    </div>
                </FormItem>
                <div class="button-content clearfix">
                    <Button
                        type="success"
                        :disabled="sendDisable"
                        @click="sendVCode()"
                        class="pull-right"
                    >
                        {{$t('port.login.send_code', { defaultValue: '发送验证码' })}}&nbsp;
                        <span v-if="sendDisable">({{sendCount}})</span>
                        <Icon type="ios-send" />
                    </Button>
                </div>
                <FormItem class="login-item" prop="vCode">
                    <Input class="phone-input" v-model="phoneForm.vCode" :placeholder="$t('port.login.input_phone_code', { defaultValue: '输入手机验证码' })"></Input>
                </FormItem>
                <div class="button-content clearfix">
                    <Button type="primary" class="pull-right" @click="submitPhoneLogin">
                        {{ $t("port.login.login") }}&nbsp;
                        <Icon type="md-arrow-forward" />
                    </Button>
                </div>
                <!-- MFA验证时才可切换 -->
                <a v-if="loginCheckType === 2" style="display: block; margin: 10px 0;" @click="changeValidType">{{$t('port.login.change_verf_type', { defaultValue: '使用其他方式验证' })}}</a>
            </Form>
        </div>
    </div>
</template>

<script>
import {
    HttpSendMFACode,
} from "@/service/port";
export default {
    props: ["loginCheckType", "phone", "sendImmediately"],
    data() {
        return {
            phoneForm: {
                phone: '',
                vCode: '',
            },
            sendDisable: false,
            sendTimer: null,
            sendTimeCount: 30,
            sendCount: 0,
        };
    },
    watch: {
        phone: {
            immediate: true,
            handler (val) {
                if (!val) return
                this.phoneForm.phone = val

            }
        },
        // 发送验证码计时
        sendCount: {
            handler (val) {
                if (val === 0) this.sendDisable = false
                else this.sendDisable = true
            }
        },
        sendImmediately: {
            immediate: true,
            handler (val) {}
        }
    },
    mounted () {
        // 登录验证 0 不需验证 1 VCODE-IP地址变化需要验证手机号 2 MFA-SMS-验证手机号
        switch (this.loginCheckType) {
            case 1: 
            case 2: {
                if (this.sendImmediately) {
                    this.sendVCode()
                }
            }
            break;
        }
    },
    methods: {
        /**
         * 手机号设置星号屏蔽
         */
        setBlur(number) {
            let size = 7;
            let result = number;
            for (let i = 0; i < size; i++) {
                result = result.replace(result[i], "*");
            }
            return result;
        },
        /**
         * 发送验证码
         */
        async sendVCode () {
            console.log(this.phoneForm.phone)
            this.$refs.phoneForm.validateField('phone', valid => {
                if (!valid) {
                    HttpSendMFACode({
                        via: 2,
                        idlabel: this.phoneForm.phone,
                        operation: "login",
                    }).then(res => {
                        this.setSendTimeCount()
                    }, err => {
                        this.$VMessage.error(err.message)
                    })
                }
            })
        },
        /**
         * 设置倒计时
         */
        setSendTimeCount () {
            this.sendCount = this.sendTimeCount
            this.sendTimer = setInterval(() => {
                if (this.sendCount === 0) {
                    return clearInterval(this.sendTimer)
                }
                this.sendCount --
            }, 1000)
        },
        /**
         * 手机登录
         */
        async submitPhoneLogin () {
            await this.$refs.phoneForm.validate(valid => {
                if (valid) {
                    this.$emit('on-commit', this.phoneForm)
                }
            });
            return false;
        },/**
         * 切换验证方式
         */
        changeValidType () {
            this.$emit('on-switch')
        },
    },
    computed: {
        rules() {
            return {
                phone: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^1(?:70\d|(?:9[89]|8[0-24-9]|7[135-8]|66|5[0-35-9])\d|3(?:4[0-8]|[0-35-9]\d))\d{7}$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.phone", {
                                            defaultValue: "请输入手机格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ],
                vCode: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (/^[0-9]{6}$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error(this.$t('port.login.input_six_number', { defaultValue: "请输入6位数字验证码" })));
                            }
                        },
                    },
                ],
            };
        },
    },
};
</script>